import PropTypes from 'prop-types';
import React, { useCallback, useContext } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { getRoutePathById } from '@bingads-webui-react/with-site-map';
import { setClarityTag } from '@bingads-webui-universal/clarity';
import { CREATE_INTENT, EDIT_INTENT } from './common/constants/intents';
import { LiftMeasurementWizard } from './wizard/wizard';

export const LiftMeasurementForm = ({ intent, siteMap }) => {
  const { scope } = useContext(ScopeContext);

  const onCancel = useCallback(() => {
    const route = getRoutePathById(siteMap, 'lift-measurement');
    if (intent === EDIT_INTENT) {
      scope.remove('liftExperimentId');
      setClarityTag({
        IsCancellingEditLiftExperiment: true,
      });
    } else {
      setClarityTag({
        IsCancellingCreateLiftExperiment: true,
      });
    }
    scope.save(route);
  }, [intent, scope, siteMap]);

  const onSaveAndExit = useCallback(() => {
    const route = getRoutePathById(siteMap, 'lift-measurement');
    if (intent === EDIT_INTENT) {
      scope.remove('liftExperimentId');
    }
    scope.save(route);
  }, [intent, scope, siteMap]);

  return (
    <LiftMeasurementWizard
      intent={intent}
      onCancel={onCancel}
      onSaveAndExit={onSaveAndExit}
    />
  );
};

LiftMeasurementForm.propTypes = {
  intent: PropTypes.oneOf([
    CREATE_INTENT,
    EDIT_INTENT,
  ]).isRequired,
  siteMap: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
};
